import { render, staticRenderFns } from "./ShopTripDetail.vue?vue&type=template&id=298503a3&scoped=true&"
import script from "./ShopTripDetail.vue?vue&type=script&lang=js&"
export * from "./ShopTripDetail.vue?vue&type=script&lang=js&"
import style0 from "./ShopTripDetail.vue?vue&type=style&index=0&id=298503a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298503a3",
  null
  
)

export default component.exports